export const ENVIRONMENT_SET_FROM_DOTENV = 'ENVIRONMENT_SET_FROM_DOTENV';
